import Box from '@mui/material/Box';

export default function Breakout({children, side="left", pos="top", bkg="primary"}){
	const outerSx = {
		position: "relative",
		width: "100%",
    display: "flex",
	};
	const innerSx = {
		position: "absolute",
		background: bkg,
	};
	if(pos === "top"){
		innerSx.mt = 3;
	}else if(pos === "btm"){
		innerSx.mb = 3;
	}else{
		throw new Error("Unsuppoted pos");
	}
	if(side === "left"){
		outerSx.marginLeft = "-100%";
    outerSx.flexDirection = "row-reverse";
		innerSx.mr = 6;
	}else if(side === "right"){
		outerSx.marginRight = "-100%";
		innerSx.ml = 6;
	}else{
		throw new Error("Unsuppoted side");
	}
	return (
			<Box sx={outerSx}>
				<Box sx={innerSx}>
					{children}
				</Box>
			</Box>
	)
}
